<template>
  <SettleBillList :fixed-status="2" />
</template>
<script lang="ts" setup>
import SettleBillList from './SettleBillList.vue'
defineOptions({ name: 'TradeAreaAgentSettleStatus2' })
</script>
